import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/companies_/$companyId/users')({
  staticData: { title: 'Users' },
})
